export const NAV = {
  home: "nav-home",
  homeLink: "nav-home-link",
  shop: "nav-shop",
  about: "nav-about",
  contact: "nav-contact",
  articles: "nav-articles",
  admin: "nav-admin",
  cart: "nav-cart",
  account: "nav-account",
  cartCount: "nav-cart-count",
  logoutBtn: "nav-logout-btn",
};

export const HOME = {
  heroCta: "home-hero-cta",
  heroTitle: "home-hero-title",
  featuredGrid: "home-featured-grid",
  categoryPouches: "home-cat-pouches",
  categoryVapes: "home-cat-vapes",
  newsletterEmail: "home-newsletter-email",
  newsletterSubmit: "home-newsletter-submit",
  shareInput: "home-share-input",
  shareSubmit: "home-share-submit",
  shareFromInput: "home-share-from-input",
};

export const PRODUCT = {
  card: "product-card",
  cardLink: "product-card-link",
  addToCart: "product-add-to-cart",
  variantOption: "product-variant-option",
  qtyInput: "product-qty",
  price: "product-price",
  gallery: "product-gallery",
};

export const CART = {
  drawerOpen: "cart-drawer-open",
  itemsList: "cart-items-list",
  removeBtn: "cart-remove",
  qtyInput: "cart-qty",
  subtotal: "cart-subtotal",
  checkoutBtn: "cart-checkout-btn",
  emptyMsg: "cart-empty-msg",
};

export const CHECKOUT = {
  firstName: "checkout-firstname",
  lastName: "checkout-lastname",
  email: "checkout-email",
  phone: "checkout-phone",
  address: "checkout-address",
  discount: "checkout-discount",
  applyDiscount: "checkout-apply-discount",
  redeemPoints: "checkout-redeem-points",
  payBtn: "checkout-pay-btn",
  summarySubtotal: "checkout-summary-subtotal",
  summaryTotal: "checkout-summary-total",
  successMsg: "checkout-success-msg",
  cancelMsg: "checkout-cancel-msg",
};

export const AUTH = {
  loginEmail: "auth-login-email",
  loginPassword: "auth-login-password",
  loginSubmit: "auth-login-submit",
  registerName: "auth-register-name",
  registerEmail: "auth-register-email",
  registerPassword: "auth-register-password",
  registerSubmit: "auth-register-submit",
  errorMsg: "auth-error-msg",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  dashboard: "admin-dashboard",
  tabProducts: "admin-tab-products",
  tabContent: "admin-tab-content",
  tabDiscounts: "admin-tab-discounts",
  tabOrders: "admin-tab-orders",
  tabNewsletter: "admin-tab-newsletter",
  productAddBtn: "admin-product-add",
  productSaveBtn: "admin-product-save",
  productDeleteBtn: "admin-product-delete",
  templateDownload: "admin-template-download",
  bulkUploadInput: "admin-bulk-upload-input",
  bulkUploadBtn: "admin-bulk-upload-btn",
  contentSaveBtn: "admin-content-save",
  discountAdd: "admin-discount-add",
  discountSave: "admin-discount-save",
};

export const CONTACT_PAGE = {
  name: "contact-name",
  email: "contact-email",
  message: "contact-message",
  submit: "contact-submit",
};
